export default {
  emmitedCountry: 'Honduras y Estados Unidos'
}
